import { PotionTrackingPageType } from '~/types/pages/page-type.types'

export function useTrackingHelper() {
  const route = useRoute()

  const { pageType, slugUrl } = useBaseRoutes()

  const ORIGIN_PAGE_TYPE = {
    homepage: PotionTrackingPageType.HOMEPAGE,
    brands: `${PotionTrackingPageType.BRAND}_${slugUrl.value}`,
    categories: `${PotionTrackingPageType.CATEGORY}_${route.path.replace(
      '/categories/',
      ''
    )}`,
    cart: PotionTrackingPageType.CART,
  }

  /*
  Required format for origin param: <page_type>|<recommendation_strategy>
  - Homepage: 'homepage|potion'
  - Brands: 'brand_sephora-collection|tf4rec-honeybee'
  - Categories: 'category_makeup|aws'
  - Landing Page: 'pages/christmas-gift-ideas|tf4rec-honeybee'

  recommendation_strategy will only be passed if source is recommendation_api i.e. Potion
  for the rest of the carousels the value will be "homepage", "brand_sephora-collection", "category_makeup", "pages/christmas-gift-ideas"
  */

  const carouselOriginPageType = computed(
    () =>
      ORIGIN_PAGE_TYPE[pageType?.value as keyof typeof ORIGIN_PAGE_TYPE] ||
      route.path
  )

  const ga_session_id = computed(
    () => useCookie('_ga_6KSFTBFXP6').value?.split('.')[2]
  )

  return {
    carouselOriginPageType,
    ga_session_id,
  }
}
